<template>
  <div>
    <filter-bar ref="filter" mode="year" :scope="scope"
                show-customer
                export-code="EEForEduNewCustomerStats" @change="onFilter" @export="toExport" />
    <div class="tip">{{ filter.year }} 年加盟的研修班/体验班客户，业绩与签到统计到 {{ filter.endMonth }} 月末；"总"= 余额×1 + 零售价×0.5 + 赠送×2/3</div>
    <el-table v-loading="listLoading" :data="list" border size="small">
      <el-table-column label="客户姓名" prop="customerName" align="center"
                       min-width="90"
                       fixed />
      <el-table-column label="折扣组" prop="levelName" align="center" width="80" />
      <el-table-column label="省" prop="provinceName" align="center" width="80" />
      <el-table-column label="市" prop="cityName" align="center" width="90" />
      <el-table-column label="直属技术老师" prop="technicianName" align="center" width="100" />
      <el-table-column label="加盟时间" prop="joinTime" align="center" width="150" />
      <el-table-column v-for="m in monthCount" :key="m" :label="m + '月业绩'" align="center">
        <el-table-column label="零售价" align="center" width="80">
          <template slot-scope="{row}">{{ cell(row, m, 'xiaoduMoney') }}</template>
        </el-table-column>
        <el-table-column label="赠送" align="center" width="80">
          <template slot-scope="{row}">{{ cell(row, m, 'giftMoney') }}</template>
        </el-table-column>
        <el-table-column label="余额" align="center" width="80">
          <template slot-scope="{row}">{{ cell(row, m, 'balanceMoney') }}</template>
        </el-table-column>
        <el-table-column label="总" align="center" width="90">
          <template slot-scope="{row}"><b>{{ cell(row, m, 'totalMoney') }}</b></template>
        </el-table-column>
      </el-table-column>
      <el-table-column :label="`1-${monthCount}月月均进货`" prop="avgMonthlyMoney" align="center" width="110" />
      <el-table-column label="扫码签到次数" prop="signCount" align="center" width="100" />
      <el-table-column label="升级体验班时间" prop="oneUpgradeTime" align="center" width="150" />
    </el-table>
    <pagination v-show="total > 0" :total="total" :page-no.sync="query.pageNo"
                :page-size.sync="query.pageSize"
                @pagination="doQueryList" />
  </div>
</template>

<script>
import eduStatsApi from '@/api/count/eduStats'
import Pagination from '@/components/Pagination'
import filterBar from './filterBar.vue'

/**
 * 新加盟客户年度进货（年度模板）
 * 月份列按 endMonth 动态展开
 */
export default {
  components: { Pagination, filterBar },
  props: { scope: { type: Object, default: () => ({}) } },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: false,
      filter: {},
      query: { pageNo: 1, pageSize: 20 }
    }
  },
  computed: {
    monthCount() {
      // 以后端返回为准（year/endMonth 缺省时后端会补），列表为空时退回筛选值
      if (this.list.length && this.list[0].months) return this.list[0].months.length
      return this.filter.endMonth || 0
    }
  },
  mounted() {
    this.filter = this.$refs.filter.buildQuery()
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    cell(row, m, key) {
      const c = row.months && row.months[m - 1]
      return c ? c[key] : ''
    },
    onFilter(q) {
      this.filter = q
      this.doQueryList({ pageNo: 1 })
    },
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) this.query.pageNo = pageNo
      if (pageSize) this.query.pageSize = pageSize
      this.listLoading = true
      eduStatsApi.newCustomerList({ ...this.filter, ...this.query }).then(({ data }) => {
        this.list = (data && data.list) || []
        this.total = (data && data.total) || 0
      }).catch(() => {
        this.list = []
        this.total = 0
      }).finally(() => { this.listLoading = false })
    },
    toExport() {
      this.$router.push('/export/list?code=EEForEduNewCustomerStats')
    }
  }
}
</script>

<style scoped>
.tip {
  margin: 0 0 10px;
  color: #909399;
  font-size: 12px;
}
</style>
